export enum TipoCartaConclusion {
  CARTA_RECONOCIMIENTO = 'CARTA_RECONOCIMIENTO',
  CARTA_NO_ADEUDO = 'CARTA_NO_ADEUDO',
}
